<script>
import { mapActions } from "vuex";
import numberMixin from "@/mixins/numberMixin";
import NewDistrict from "./New/Index";

export default {
  components: {
    NewDistrict
  },
  mixins: [numberMixin],
  props: {
    professional: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      districts: [],
      list: [],
      newDistrict: false,
      preloader: false
    };
  },
  methods: {
    ...mapActions("professionals", ["getDistricts", "addDistricts"]),
    async getAll() {
      try {
        this.districts = await this.getDistricts(this.professional.id);
        this.list = this.districts;
      } catch (e) {
        this.$toast.error(e);
      }
    },
    toggleFromList(district) {
      this.list.find(item => item.id === district.id)
        ? (this.list = this.list.filter(item => item.id != district.id))
        : this.list.push(district);
    },
    onList(id) {
      return this.list.find(item => item.id === id) ? true : false;
    },
    async submit() {
      this.preloader = true;

      try {
        let res = await this.addDistricts({
          professional_id: this.$route.params.id,
          districts: this.list
        });

        if (res) this.getAll();
      } catch (e) {}

      this.preloader = false;
    }
  },
  created() {
    this.getAll();
  }
};
</script>

<template>
  <div class="table">
    <div class="new-group" @click="newDistrict = !newDistrict">
      <img src="../../../../../../static/plus.svg" /> Adicionar bairros
    </div>

    <table>
      <thead>
        <tr>
          <th>Cidade</th>
          <th>Bairro</th>
          <th>Nota Mínima</th>
          <th>Valor Hora</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="district in districts" :key="district.id">
          <td>{{ district.city.display_name }}</td>
          <td>{{ district.display_name }}</td>
          <td>{{ district.rating.rating_min | intToDecimal }}</td>
          <td>{{ district.pricing.price_per_hour | intToCurrency }}</td>
          <td class="icon" @click="toggleFromList(district)">
            <img
              v-if="onList(district.id)"
              :src="'/static/icon_check_circle.svg'"
            />
            <img v-else :src="'/static/icon_times_circle.svg'" />
          </td>
        </tr>
      </tbody>
    </table>

    <div class="btn-group mt-20">
      <button
        v-if="districts != list"
        class="btn bg-purple"
        :class="{ 'btn--loading': preloader }"
        @click="submit"
      >
        <span>salvar alterações</span>
      </button>
    </div>

    <NewDistrict
      v-if="newDistrict"
      :districts="districts"
      @close="newDistrict = false"
      @refresh="getAll()"
    />
  </div>
</template>

<style scoped>
.icon {
  width: 15px;
  cursor: pointer;
}

.icon img {
  width: 15px;
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Districts/Index.vue